import { AdvertisementTranslations } from '@app/const/translations';
import { IAdvertisement } from './types';

export const ADVERTISEMENTS: IAdvertisement[] = [
  { // Кейс
    background: `/assets/img/login/login_advertisement_1.jpg`,
    backgroundPosition: 'bottom',
    title: AdvertisementTranslations.n1.title,
    main: AdvertisementTranslations.n1.main,
    url: 'https://infologistics.ru/keysy/kak-podgotovit-k-nalogovomu-monitoringu-dokumenty-iz-raznykh-istochnikov-opyt-makita',
  },
  { // Новость (Статья)
    background: `/assets/img/login/login_advertisement_2.jpg`,
    backgroundPosition: 'bottom',
    title: AdvertisementTranslations.n2.title,
    main: AdvertisementTranslations.n2.main,
    url: 'https://infologistics.ru/news/infologistics-v-top-500-it-kompanii-rossii',
  },
  { // Услуга
    background: `/assets/img/login/login_advertisement_3.jpg`,
    backgroundPosition: 'bottom',
    title: AdvertisementTranslations.n3.title,
    main: AdvertisementTranslations.n3.main,
    url: 'https://infologistics.ru/cifrovaya-kancelyariya',
  },
  { // Новость
    background: `/assets/img/login/login_advertisement_4.jpg`,
    backgroundPosition: 'bottom',
    title: AdvertisementTranslations.n4.title,
    main: AdvertisementTranslations.n4.main,
    url: 'https://infologistics.ru/news/infologistics-v-top-500-it-kompanii-rossii',
  },
];

// Массив индексов с одинаковыми слайдами, которые не должны повторяться (может быть пустым)
export const ADVERTISEMENTS_SAME_SLIDE_IDX = [1,3];
